import { Injectable } from '@angular/core';
import { UserLimit, UserLimitKind } from '@ca/core/models';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { Notification, NotificationBuilder } from '../../core/models/notification.model';
import { LimitsNotificationBuilder } from './builders/limits-notification.builder';
import { SubscriptionEndsNotificationBuilder } from './builders/subscription-ends-notification.builder';

export interface NotificationsManager {
    readonly notifications$: Observable<Map<string, Notification>>;
}
@Injectable()
export class NotificationsComponent {}
@Injectable()
export class NotificationsFactory {
    constructor(private translateService: TranslateService) {}

    getLimitsNotificationBuilders(limits: Map<UserLimitKind, UserLimit | string>): NotificationBuilder[] {
        const builders: NotificationBuilder[] = [...limits.entries()]
            .filter(([kind]) => kind === 'WorkflowExecutionTimeInSeconds' || kind === 'StorageInBytes')
            .reduce((acc: NotificationBuilder[], [kind, limit]: [UserLimitKind, string | UserLimit]) => {
                const builder: NotificationBuilder = new LimitsNotificationBuilder(this.translateService)
                    .setUserLimit(limit as UserLimit)
                    .setType(kind === 'WorkflowExecutionTimeInSeconds' ? 'computational_time' : 'storage')
                    .setThreshold(80);
                acc.push(builder);
                return acc;
            }, []);
        return builders;
    }

    getSubscriptionEndsNotificationBuilders(limits: Map<UserLimitKind, UserLimit | string>): NotificationBuilder[] {
        const builders: NotificationBuilder[] = [...limits.values()]
            .filter(limit => typeof limit === 'string')
            .reduce((acc: NotificationBuilder[], limit: string | UserLimit) => {
                const builder: NotificationBuilder = new SubscriptionEndsNotificationBuilder(this.translateService)
                    .setType('subscription_ends')
                    .setEndDate(limit as string)
                    .setThreshold(7);
                acc.push(builder);
                return acc;
            }, []);
        return builders;
    }
}
